import React, { useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import ProductFactory from 'factories/Products';
import ProductQuantityDropdown from 'components/ProductControls/ProductQuantityDropdown';
import style from './style.scss';//NOSONAR

const ProductQuantity = (props) => {

    const item = props.item;
    const incrementQty = props.incrementQty;
    const decrementQty = props.decrementQty;
    const showMaxQuantity = props.showMaxQuantity;
    const oldQty = props.oldQty;

    const [quantity, setQuantity] = useState(props.quantity);
    const [unit, setUnit]= useState('');
    const [openDropdown, setOpenDropdown] = useState(false);

    const quantityRef = useRef();

    let quantityUnit = '';
    let qtyNumber = 0;
    let _quantity = [];

    
    const _openDropdown = (value) => {
        showMaxQuantity(false)
        setOpenDropdown(value);
    }

    useEffect(() => {
        if(!item) return '';

        qtyNumber = parseFloat(props.quantity * item.unitMultiplier).toFixed(2);
        if ((qtyNumber - Math.floor(qtyNumber)) === 0) {
            qtyNumber = Math.floor(qtyNumber);
        }
        quantityUnit = ProductFactory.formatWeight(item.measurementUnit, qtyNumber);
        _quantity = quantityUnit.split(' ');
        setUnit(_quantity[1]);
        setQuantity(_quantity[0]);
        if(quantityRef.current) quantityRef.current.value = _quantity[0];

    }, [props.quantity, item]);


    if(quantity === undefined) return '';

    if(!item.unitSale || (item.unitSale === undefined)) {
        const configQty = {
            unitMultiplier: item.unitMultiplier, 
            maxItemsOrigin: item.maxItemsOrigin, 
            maxItems: item.maxItems, 
            unitSale: item.unitSale,
            measurementUnit: item.measurementUnit,
            quantity
        }

        return (
            <>
                {!props.dropdownIsHidden && openDropdown && (
                    <ProductQuantityDropdown
                        configQty={configQty}
                        showMaxQuantity={showMaxQuantity}
                        decrementQty={decrementQty}
                        incrementQty={incrementQty}
                        oldQty={oldQty}
                    />
                )}
                <span className="wrapper-product-quantity">
                    <span className="quantity-unit">
                        {quantity} {unit}
                    </span>
                    {!props.dropdownIsHidden && (
                        <button
                            className={'font-icn arrow-up dropdown-quantity mobile-click' + (openDropdown ? ' open' : '')}
                            onClick={() => _openDropdown(!openDropdown)}></button>
                    )}
                </span>
            </>
        )   
    } else {
        return (
            <>
                <span>{quantity} un.</span><span>({quantityUnit})</span>
            </>
        )
    }



};

ProductQuantity.propTypes = {
    quantity: PropTypes.number,
    item: PropTypes.object
};

export default ProductQuantity;